<template>
  <v-container fluid class="mt-16 px-6">
    <div>
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Warranty Policies</h2>
          <v-spacer></v-spacer>
          <add-warranty-policy-modal />
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items="warranty_policies"
            :headers="headers"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search policies..."
                prepend-icon="mdi-magnify"
                class="mx-4"
                single-line
                hide-details
              ></v-text-field>
            </template>
            <template v-slot:item.major_parts="{ item }">
              <span v-if="item.name === 'Regular Warranty'" class="grey--text"
                >—</span
              >
              <span v-else
                >{{ item.major_parts_warranty_value }}
                {{ item.major_parts_warranty_unit }}</span
              >
            </template>
            <template v-slot:item.minor_parts="{ item }">
              <span v-if="item.name === 'Regular Warranty'" class="grey--text"
                >—</span
              >
              <span v-else
                >{{ item.minor_parts_warranty_value }}
                {{ item.minor_parts_warranty_unit }}</span
              >
            </template>
            <template v-slot:item.service="{ item }">
              <span v-if="item.name === 'Regular Warranty'" class="grey--text"
                >—</span
              >
              <span v-else
                >{{ item.service_warranty_value }}
                {{ item.service_warranty_unit }}</span
              >
            </template>
            <template v-slot:item.description="{ item }">
              <span
                v-if="item.name === 'Regular Warranty'"
                class="blue--text caption"
              >
                Uses each item's own warranty duration
              </span>
              <span v-else>{{ item.description }}</span>
            </template>
            <template v-slot:item.warranty_type="{ item }">
              <v-chip small outlined>{{
                getWarrantyTypeLabel(item.warranty_type)
              }}</v-chip>
            </template>
            <template v-slot:item.color="{ item }">
              <v-chip small :color="item.color || 'blue'" dark>{{
                item.name
              }}</v-chip>
            </template>
            <template v-slot:item.is_active="{ item }">
              <v-chip small :color="item.is_active ? 'green' : 'grey'" dark>
                {{ item.is_active ? "Active" : "Inactive" }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon small color="primary" @click="openEdit(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small color="red" @click="deletePolicy(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <edit-warranty-policy-modal
            :show.sync="editDialog"
            :policy="selectedPolicy"
          />
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import AddWarrantyPolicyModal from "../components/WarrantyPolicy/addWarrantyPolicyModal.vue";
import EditWarrantyPolicyModal from "../components/WarrantyPolicy/editWarrantyPolicyModal.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { AddWarrantyPolicyModal, EditWarrantyPolicyModal },
  computed: {
    ...mapGetters({
      warranty_policies: "warranty_policy/warranty_policies",
    }),
  },
  methods: {
    ...mapActions({
      get_warranty_policies: "warranty_policy/get_warranty_policies",
      delete_warranty_policy: "warranty_policy/delete_warranty_policy",
    }),
    getWarrantyTypeLabel(type) {
      const labels = {
        regular: "Regular",
        desktop: "Desktop PC",
        laptop: "Laptop",
        cctv: "CCTV",
        repairs: "Repairs",
        printer: "Printer",
      };
      return labels[type] || type || "Regular";
    },
    openEdit(policy) {
      this.selectedPolicy = Object.assign({}, policy);
      this.editDialog = true;
    },
    deletePolicy(policy) {
      if (policy.name === "Regular Warranty") {
        alert(
          "The 'Regular Warranty' policy cannot be deleted. It is a system default."
        );
        return;
      }
      if (confirm("Are you sure you want to delete this warranty policy?")) {
        this.delete_warranty_policy(policy.id);
      }
    },
  },
  data() {
    return {
      search: "",
      editDialog: false,
      selectedPolicy: {},
      headers: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Type", value: "warranty_type" },
        { text: "Description", value: "description" },
        { text: "Major Parts", value: "major_parts", sortable: false },
        { text: "Minor Parts", value: "minor_parts", sortable: false },
        { text: "Service", value: "service", sortable: false },
        { text: "Color", value: "color", sortable: false },
        { text: "Active", value: "is_active" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  created() {
    if (this.warranty_policies.length == 0) return this.get_warranty_policies();
  },
};
</script>
